<template>
  <div class="pa-2" style="height: calc(100vh - 112px); overflow-x: auto; overflow-y: visible">
    <v-layout
      justify-start
      align-start
      fill-height
      row
      class="mb-0 ml-0"
      :style="{ width: groups.length * 310 + 'px' }"
    >
      <template v-for="group in groups">
        <status-line :value="group" :key="group"></status-line>
      </template>
    </v-layout>
  </div>
</template>

<script>
import StatusLine from './StatusLine'
export default {
  data: () => {
    return {
      groups: ['จองผ่านตัวแทน', 'แจ้งปัญหา', 'ติดต่อ Admin', 'ปิดการขาย']
    }
  },
  components: {
    StatusLine
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/qualityexpress/StatusBoard.vue